import { render, staticRenderFns } from "./PasswordConfirmInput.vue?vue&type=template&id=674ca4dd&scoped=true"
import script from "./PasswordConfirmInput.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ca4dd",
  null
  
)

export default component.exports